import BookForm from "components/shared/book/form";
import React from "react";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class FormFuelCard extends BookForm {
    renderBody = () => {
        const { config } = this.props;
        return (
            <Markup
                {...config}
                renderSelect={this.renderSelect}
                renderField={this.renderField}
                renderCheckbox={this.renderCheckbox}
                data={this.state}
            />
        );
    };
}

const ConfiguredForm = (props) => <FormFuelCard {...props} config={config} initialState={initialState} />;

export default ConfiguredForm;
